import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { Pagination } from 'antd';
import usePageLimit from '../hooks/usePagination';

const PageLimitSwitch = ({
  limit, resourceType, limits, totalRecords, currentPage,
}) => {
  const {
    handlePageLimitChange, pageLimitOptions, setPageLimitOptions, handlePageChange,
  } = usePageLimit();

  useEffect(() => {
    setPageLimitOptions(limits);
  }, [limits]);

  const onChange = (page, pageSize) => {
    if (pageSize !== limit) {
      handlePageLimitChange(pageSize, resourceType);
    }
    if (page !== currentPage) {
      handlePageChange(page, resourceType);
    }
  };

  return (
    <div>
      <Pagination
        current={currentPage}
        total={totalRecords}
        onChange={onChange}
        pageSize={limit}
        pageSizeOptions={pageLimitOptions}
        showSizeChanger
      />
    </div>
  );
};

PageLimitSwitch.propTypes = {
  limit: PropTypes.number,
  limits: PropTypes.arrayOf(PropTypes.number),
  resourceType: PropTypes.string.isRequired,
  totalRecords: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
};

PageLimitSwitch.defaultProps = {
  limit: 10,
  limits: [10, 20, 50, 100],
};

export default React.memo(PageLimitSwitch);
